/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import Listable from '@zcode/nr/es/shared/bizos/listable'
import type {
  CardBackResponse,
  CardBackReview,
  CardBackReviewsSummary,
  CardBackSupplementalDescription,
  Listable as ListableType,
  RawListable,
} from '@zcode/state-type'

interface Props {
  featuredArray:
    | {
        listables: RawListable[]
        matching: number
      }
    | RawListable[]
    | undefined
  featuredCardbacks: CardBackResponse
  seenUids: Set<ListableType['uId']>
  featuredApiLimit: number
  spotlightLimit: number
}

export const appendFeaturedData = ({
  featuredArray,
  featuredCardbacks,
  seenUids,
  featuredApiLimit,
  spotlightLimit,
}: Props) => {
  let review: CardBackReview | undefined
  let supple_description: CardBackSupplementalDescription | undefined
  let reviews_summary: CardBackReviewsSummary | undefined
  if (featuredArray && 'listables' in featuredArray) {
    const featured: ListableType[] = []
    for (const listable of featuredArray.listables) {
      const groupIdString = String(listable.group_id)
      if (featuredCardbacks[groupIdString]) {
        review = featuredCardbacks[groupIdString].review
        supple_description = featuredCardbacks[groupIdString].supple_description
        reviews_summary = featuredCardbacks[groupIdString].reviews_summary
      }
      const featuredListable = Listable.fromJS({
        supple_description,
        is_featured: true,
        review,
        reviews_summary,
        ...listable,
      })

      if (
        !seenUids.has(featuredListable.uId) &&
        featured.length < featuredApiLimit - spotlightLimit
      ) {
        featured.push(featuredListable)
      }
    }
    return featured
  }

  if (Array.isArray(featuredArray) && featuredArray.length) {
    return featuredArray.map((listable: RawListable) =>
      Listable.fromJS({
        review,
        is_featured: true,
        ...listable,
      })
    )
  }
}
